/* OCP Shopify cart layer — overrides ocp-app.js's localStorage cart with the real Shopify
 * Cart AJAX API (/cart/add.js, /cart/change.js, /cart.js). Self-contained: capture-phase
 * handlers take over add-to-cart / pdp-add / open-cart / line edits, and it renders the existing
 * popup, drawer and cart-page shells (same markup classes + data-bind hooks) from the live cart. */
(function () {
  var R = window.OCP_ROUTES || {};
  if (!R.cart_add) return;
  var FREE_SHIP = (window.OCP_FREE_SHIP || 75) * 100;
  var current = null;
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function money(cents) { return '$' + (Math.round(Number(cents) || 0) / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function $all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function setBind(name, val) { $all('[data-bind="' + name + '"]').forEach(function (e) { e.textContent = val; }); }

  /* ----------------------------------------------------------------------
     GA4 cart events.

     The cart opens as a popup, so the browser never loads a new page and Google records nothing —
     which is why reported cart views fell ~89% after the relaunch while traffic rose. (The old site
     redirected to /cart after every add, so much of the previous figure was that redirect rather
     than shoppers choosing to view their cart; the two numbers will not line up, and shouldn't.)

     Sent straight to the gtag already on the page from Shopify's Google & YouTube channel — there is
     no Tag Manager container on this store. Deliberately NOT sending add_to_cart: Shopify's own
     pixel already sends it, and a second one would double-count. remove_from_cart it does not send.
     ---------------------------------------------------------------------- */
  function gaItems(items) {
    return (items || []).map(function (i, idx) {
      return {
        item_id: String(i.sku || i.variant_id || i.id || ''),
        item_name: i.product_title || i.title || '',
        item_variant: (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : undefined,
        item_brand: i.vendor || undefined,
        price: (Number(i.final_price != null ? i.final_price : i.price) || 0) / 100,
        quantity: Number(i.quantity) || 1,
        index: idx
      };
    });
  }
  function gaEvent(name, items, valueCents) {
    if (typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', name, {
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        value: (Number(valueCents) || 0) / 100,
        items: gaItems(items)
      });
    } catch (err) { /* analytics must never break the cart */ }
  }

  function rowHTML(item, isTable) {
    var media = item.image
      ? 'background-image:url(' + esc(item.image) + ');background-size:contain;background-repeat:no-repeat;background-position:center'
      : 'background:#efece6';
    var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    // Per-line unit from the qty-tier option value ("yard(s)", "spool(s)", "set(s)", "Pattern(s)", …) — never hard-coded.
    var _uw = '', _ov = item.options_with_values || [];
    for (var _i = 0; _i < _ov.length; _i++) {
      var _v = String(_ov[_i].value || '');
      if (/\(s\)|\d\s*\+|swatch|sample/i.test(_v)) { _uw = _v.split(' ')[0]; break; }
    }
    if (!_uw && _ov.length) _uw = String(_ov[0].value || '').split(' ')[0];
    if (!_uw) _uw = 'yard(s)';
    var _uclean = _uw.replace(/\(s\)/i, '');
    if (isTable) {
      return '<article class="cart-row" data-key="' + esc(item.key) + '">'
        + '<div class="cart-row__product">'
        +   '<a class="cart-row__media" href="' + esc(item.url) + '" style="' + media + '" aria-label="' + esc(item.product_title) + '">'
        +     '<button type="button" class="cart-row__wish" data-action="toggle-wish" data-product="' + esc(item.handle || '') + '" aria-label="Save to wishlist" aria-pressed="false"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" aria-hidden="true"><path d="M12 21s-7-4.5-9.3-9A5.3 5.3 0 0 1 7.5 5.5c1.7 0 3.3.8 4.5 2.2 1.2-1.4 2.8-2.2 4.5-2.2A5.3 5.3 0 0 1 21.3 12C19 16.5 12 21 12 21z"/></svg></button>'
        +   '</a>'
        +   '<div class="cart-row__info"><a class="cart-row__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>'
        +     (item.sku ? '<p class="cart-row__sku">SKU# ' + esc(item.sku) + '</p>' : '')
        +     (variantLabel ? '<p class="cart-row__color">' + esc(variantLabel) + '</p>' : '')
        +   '</div>'
        + '</div>'
        + '<div class="cart-row__price"><span class="cart-row__mlabel">Price</span><span>' + money(item.final_price) + '<small> /' + esc(_uclean) + '</small></span></div>'
        + '<div class="cart-row__qty"><span class="cart-row__mlabel">QTY</span><div class="cart-row__stepper">'
        +   '<button type="button" class="cart-row__qbtn" data-action="cart-dec" aria-label="Decrease quantity"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>'
        +   '<span class="cart-row__qval"><b>' + item.quantity + '</b> ' + esc(_uw) + '</span>'
        +   '<button type="button" class="cart-row__qbtn" data-action="cart-inc" aria-label="Increase quantity"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>'
        + '</div></div>'
        + '<div class="cart-row__total"><span class="cart-row__mlabel">Total</span><span>' + money(item.final_line_price) + '</span></div>'
        + '<button type="button" class="cart-row__remove" data-action="cart-remove" aria-label="Remove ' + esc(item.product_title) + '"><svg class="cart-row__remove-x" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg><svg class="cart-row__remove-trash" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><g clip-path="url(#clip0_cart_trash)"><path d="M2.66797 4.6665H13.3346" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66797 7.3335V11.3335" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.33203 7.3335V11.3335" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.33203 4.6665L3.9987 12.6665C3.9987 13.0201 4.13917 13.3593 4.38922 13.6093C4.63927 13.8594 4.97841 13.9998 5.33203 13.9998H10.6654C11.019 13.9998 11.3581 13.8594 11.6082 13.6093C11.8582 13.3593 11.9987 13.0201 11.9987 12.6665L12.6654 4.6665" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 4.66667V2.66667C6 2.48986 6.07024 2.32029 6.19526 2.19526C6.32029 2.07024 6.48986 2 6.66667 2H9.33333C9.51014 2 9.67971 2.07024 9.80474 2.19526C9.92976 2.32029 10 2.48986 10 2.66667V4.66667" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_cart_trash"><rect width="16" height="16" fill="white"/></clipPath></defs></svg></button>'
        + '</article>';
    }
    return '<article class="cart-line" data-key="' + esc(item.key) + '">'
      + '<div class="cart-line__img" style="' + media + '"></div>'
      + '<div class="cart-line__body"><h3 class="cart-line__name">' + esc(item.product_title) + '</h3>'
      +   '<p class="cart-line__meta">' + esc(variantLabel) + '</p>'
      +   '<div class="cart-line__qty"><button type="button" data-action="cart-dec" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-action="cart-inc" aria-label="Increase">+</button></div>'
      + '</div>'
      + '<div class="cart-line__right"><span class="cart-line__price">' + money(item.final_line_price) + '</span><button type="button" class="cart-line__remove" data-action="cart-remove" aria-label="Remove">Remove</button></div>'
      + '</article>';
  }

  // Rebuild the line rows. `preserve` keeps server-rendered (Liquid) rows that already exist —
  // so the cart PAGE paints statically and doesn't flash/jump on load. The popup/drawer bodies
  // start empty, so they always render. After a user edit we patch rows in place (no rebuild).
  function renderRows(cart, force) {
    $all('[data-bind="cart-body"]').forEach(function (body) {
      // Cart PAGE body is server-rendered by Liquid — keep it (no flash/jump). Popup/drawer
      // bodies live in a hidden overlay, so rebuilding them is invisible. `force` rebuilds even
      // the server rows — needed when a line's VARIANT changes (bulk-tier swap), since the key changes.
      var inOverlay = body.closest('#cart-popup, #cart-drawer, .cart-popup, .cart-drawer');
      if (!force && !inOverlay && body.querySelector('[data-key]')) return;
      var isTable = body.getAttribute('data-cart-variant') === 'table';
      if (!cart.items.length) {
        body.innerHTML = isTable ? '<p class="cart-table__empty">Your bag is empty.</p>' : '<p class="cart-drawer__empty">Your bag is empty.</p>';
        return;
      }
      body.innerHTML = cart.items.map(function (it) { return rowHTML(it, isTable); }).join('');
    });
  }

  // In-place update of a single line's qty + line total across all shells (no innerHTML rebuild → no jump).
  function patchRow(key, cart) {
    var item = cart.items.filter(function (i) { return i.key === key; })[0];
    $all('[data-key="' + (key || '').replace(/"/g, '\\"') + '"]').forEach(function (row) {
      if (!item) { row.parentNode && row.parentNode.removeChild(row); return; }
      var q = row.querySelector('.cart-row__qval b, .cart-line__qty span');
      if (q) q.textContent = item.quantity;
      var totalCell = row.querySelector('.cart-row__total');
      if (totalCell) { var sp = totalCell.querySelectorAll('span'); if (sp.length) sp[sp.length - 1].textContent = money(item.final_line_price); }
      var lineP = row.querySelector('.cart-line__price');
      if (lineP) lineP.textContent = money(item.final_line_price);
    });
    if (!cart.items.length) renderRows(cart, false); // show the empty-state message
  }

  function render(cart, force) {
    current = cart;
    renderRows(cart, force);
    syncMeta(cart);
  }

  function syncMeta(cart) {
    current = cart;
    var count = cart.item_count;
    setBind('cart-count', String(count));
    setBind('cart-count-inline', '(' + count + ')');
    $all('.icon-btn__badge').forEach(function (b) { b.textContent = String(count); });

    var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    setBind('cart-subtotal', money(cart.total_price));
    setBind('cart-page-subtotal', money(sub));
    var hasDiscount = (cart.total_discount || 0) > 0;
    $all('[data-bind="cart-page-discount"]').forEach(function (el) {
      el.textContent = '- ' + money(cart.total_discount || 0);
      var row = el.closest('.cart-sb__line');
      if (row) row.style.display = hasDiscount ? '' : 'none'; // no "Discount  - $0.00" row when there's none
    });
    renderDiscounts(cart); // applied code + automatic discount chips (both cart page and popup)
    setBind('cart-page-shipping', cart.total_price >= FREE_SHIP ? 'FREE' : 'Calculated at checkout');
    setBind('cart-page-total', money(cart.total_price));
    setBind('cart-total', money(cart.total_price));
    setBind('cart-item-count', String(count));

    $all('[data-bind="cart-page-content"]').forEach(function (e) { e.hidden = !cart.items.length; });
    $all('[data-bind="cart-page-empty"]').forEach(function (e) { e.hidden = !!cart.items.length; });

    var rem = FREE_SHIP - cart.total_price;
    $all('[data-bind="cart-ship-msg"]').forEach(function (m) {
      m.innerHTML = rem > 0 ? ('Add <strong>' + money(rem) + '</strong> more to unlock <strong>FREE delivery</strong>') : 'You\'ve unlocked <strong>FREE delivery</strong>!';
    });
    var pct = cart.total_price >= FREE_SHIP ? 100 : Math.max(0, Math.min(100, (cart.total_price / FREE_SHIP) * 100));
    $all('[data-bind="cart-ship-bar"]').forEach(function (bar) { bar.style.width = pct.toFixed(1) + '%'; });
    $all('.cart-sb__checkout-meta, .cart-popup__checkout-meta, .cart-sticky__checkout-meta').forEach(function (e) { e.textContent = '( ' + count + ' items | ' + money(cart.total_price) + ' )'; });

    // Empty cart → disable checkout, hide the "go to bag" link (applies to popup, drawer + page).
    var isEmpty = !cart.items.length;
    $all('[data-action="checkout"]').forEach(function (b) {
      if (b.tagName === 'BUTTON') b.disabled = isEmpty;
      b.classList.toggle('is-disabled', isEmpty);
      b.setAttribute('aria-disabled', isEmpty ? 'true' : 'false');
    });
    $all('[data-bind="cart-bag-link"]').forEach(function (a) { a.hidden = isEmpty; });
    syncStickyCheckout();
  }

  function syncStickyCheckout() {
    var hasItems = current && current.item_count > 0;
    var show = hasItems && window.scrollY > 24;
    $all('.cart-sticky').forEach(function (el) { el.classList.toggle('is-visible', show); });
  }

  function fetchCart() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function openPopup() {
    var style = document.body.getAttribute('data-cart-style') === 'drawer' ? 'cart-drawer' : 'cart-popup';
    var el = document.getElementById(style) || document.getElementById('cart-popup') || document.getElementById('cart-drawer');
    if (!el) return;
    // The shopper is now looking at their cart — the moment the old site recorded as a /cart pageview.
    if (current) gaEvent('view_cart', current.items, current.total_price);
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
  }

  function addVariant(variantId, qty, trigger) {
    if (!variantId) return;
    if (trigger) { trigger.disabled = true; trigger.setAttribute('aria-busy', 'true'); }
    fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res.status) throw new Error(res.description || 'add failed'); return fetchCart(); })
      .then(function (cart) {
        // On the cart page, adding (e.g. a "Complete the Look" rec) should update the page itself,
        // not pop the mini-cart. Force a rebuild so the new line appears in the server-rendered table.
        if (document.querySelector('.cart-page, [data-cart-page]')) render(cart, true);
        else { render(cart); openPopup(); }
      })
      .catch(function (e) { console.error('OCP cart add:', e.message); })
      .finally(function () { if (trigger) { trigger.removeAttribute('aria-busy'); trigger.disabled = false; } });
  }

  function changeLine(key, qty) {
    fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { current = cart; patchRow(key, cart); syncMeta(cart); }) // in-place, no rebuild/jump
      .catch(function (e) { console.error('OCP cart change:', e.message); })
      .finally(function () { setBusy(key, false); });
  }

  // Persist the cart NOTE (Special Instructions) to the real cart so it carries to checkout.
  var CART_UPDATE = (R.cart || '/cart') + '/update.js';
  var noteTimer;
  function saveNote(value) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(CART_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value == null ? '' : value })
      }).then(function (r) { return r.json(); }).then(function (c) { current = c; }).catch(function () {});
    }, 400);
  }
  document.addEventListener('input', function (e) {
    var note = e.target.closest('textarea[name="note"], textarea[data-action="cart-comment"]');
    if (note) saveNote(note.value);
  }, true);

  // Busy state on a line's quantity controls while a change/tier-swap is in flight — shows a loader
  // and (importantly) disables the buttons so rapid clicks can't race ahead of the async cart update.
  function setBusy(key, on) {
    var sel = '[data-key="' + (key || '').replace(/"/g, '\\"') + '"]';
    $all(sel).forEach(function (row) {
      row.classList.toggle('is-busy', on);
      row.querySelectorAll('[data-action="cart-inc"],[data-action="cart-dec"],[data-action="cart-remove"]').forEach(function (b) {
        b.disabled = on; b.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    });
  }

  // Debounced quantity stepping. Each +/- click updates the shown quantity INSTANTLY and accumulates
  // locally; the real cart (and its bulk-tier variant) is committed only once, ~600ms after the LAST
  // click, using the FINAL quantity to resolve the tier. Lets a shopper click 4→40 smoothly, avoids a
  // network round-trip per click, and removes the per-click race that mis-picked the variant.
  var pendingQty = {}, pendingTimers = {};
  function setRowQtyDisplay(key, qty) {
    var sel = '[data-key="' + (key || '').replace(/"/g, '\\"') + '"]';
    $all(sel).forEach(function (row) {
      var q = row.querySelector('.cart-row__qval b, .cart-line__qty span');
      if (q) q.textContent = qty;
      row.classList.add('is-pending'); // dims the (not-yet-recomputed) line total until commit
    });
  }
  function bumpQty(item, delta) {
    var key = item.key;
    var base = pendingQty[key] != null ? pendingQty[key] : item.quantity;
    var next = Math.max(1, base + delta); // stepper stays >= 1; the Remove button deletes a line
    pendingQty[key] = next;
    setRowQtyDisplay(key, next);
    clearTimeout(pendingTimers[key]);
    pendingTimers[key] = setTimeout(function () {
      var finalQty = pendingQty[key]; delete pendingQty[key];
      var sel = '[data-key="' + (key || '').replace(/"/g, '\\"') + '"]';
      $all(sel).forEach(function (r) { r.classList.remove('is-pending'); });
      if (finalQty == null || finalQty === item.quantity) return; // no net change → nothing to commit
      setBusy(key, true);
      changeLineTier(item, finalQty); // FINAL qty decides the bulk-tier variant
    }, 600);
  }

  // ---------- Bulk-tier auto-correction ----------
  // option1 = quantity tier (e.g. "yard(s)", "yard(s) 5+", "10+", "20+", "50+", "swatch").
  // When a line's quantity crosses a tier boundary, swap it to the variant whose tier matches —
  // so a line dropped from 7→3 yds leaves the "5+" bulk price and moves to the 1-4 tier (and vice versa).
  function tierForQty(q) { q = parseInt(q, 10) || 1; return q >= 50 ? 4 : q >= 20 ? 3 : q >= 10 ? 2 : q >= 5 ? 1 : 0; }
  function tierIndexOfOpt(val) {
    var s = (val || '').toLowerCase();
    if (s.indexOf('swatch') >= 0 || s.indexOf('sample') >= 0) return -1; // not a bulk tier
    if (s.indexOf('50+') >= 0 || s.indexOf('50 +') >= 0) return 4;
    if (s.indexOf('20+') >= 0 || s.indexOf('20-49') >= 0) return 3;
    if (s.indexOf('10+') >= 0 || s.indexOf('10-19') >= 0) return 2;
    if (s.indexOf('5+') >= 0 || s.indexOf('5-9') >= 0) return 1;
    return 0;
  }
  var productCache = {};
  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }
  // Which option position (1-based) actually varies by bulk tier?
  function tierPosOf(product) {
    for (var pos = 1; pos <= 3; pos++) {
      for (var i = 0; i < product.variants.length; i++) {
        if (tierIndexOfOpt(product.variants[i]['option' + pos]) > 0) return pos;
      }
    }
    return 0; // product has no bulk tiers
  }
  // The variant for newQty's tier, keeping every OTHER option (e.g. colour) equal to the current variant.
  function resolveTierVariant(product, curVariantId, newQty) {
    if (!product || !product.variants) return null;
    var pos = tierPosOf(product); if (!pos) return null;
    var cur = null, i;
    for (i = 0; i < product.variants.length; i++) { if (product.variants[i].id === curVariantId) { cur = product.variants[i]; break; } }
    if (!cur || tierIndexOfOpt(cur['option' + pos]) < 0) return null; // current line isn't a bulk-tier variant (e.g. swatch)
    var target = tierForQty(newQty);
    for (i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (tierIndexOfOpt(v['option' + pos]) !== target) continue;
      var ok = true;
      for (var p = 1; p <= 3; p++) { if (p === pos) continue; if ((v['option' + p] || null) !== (cur['option' + p] || null)) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function changeLineTier(item, newQty) {
    var key = item.key, curVid = item.variant_id || item.id;
    if (newQty <= 0) { changeLine(key, 0); return; }
    getProduct(item.handle).then(function (product) {
      var target = resolveTierVariant(product, curVid, newQty);
      if (!target || target.id === curVid || target.available === false) { changeLine(key, newQty); return; } // same tier / no tiers / target OOS
      // Tier crossed → swap variant (add correct tier, drop old line), then force a rebuild (key changed).
      fetch(R.cart_add, { method: 'POST', headers: JSONH, body: JSON.stringify({ id: Number(target.id), quantity: newQty }) })
        .then(function (r) { return r.json(); })
        .then(function (res) { if (res.status) throw new Error(res.description || 'add failed'); return fetch(R.cart_change, { method: 'POST', headers: JSONH, body: JSON.stringify({ id: key, quantity: 0 }) }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { current = cart; render(cart, true); })
        .catch(function (e) { console.error('OCP tier swap:', e.message); changeLine(key, newQty); });
    });
  }

  // ---------- Discounts via the Cart AJAX API (no page reload) ----------
  // /cart/update.js { discount } applies (or '' clears) a code and returns the cart. cart.discount_codes
  // is [{code, applicable}] — `applicable:false` means invalid/not-applicable for the current bag.
  function discountState(cart, code) {
    if (!code) return { found: false };
    var c = code.trim().toLowerCase();
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if ((codes[i].code || '').toLowerCase() === c) return { found: true, applicable: codes[i].applicable !== false };
    }
    return { found: false };
  }
  function showPromo(cart, code) {
    // On success show nothing here — the applied-discount chip (rendered below by renderDiscounts) is
    // the confirmation. Only surface a message when the entered code is invalid/not applicable.
    var msg = '', cls = '';
    if (code) {
      var st = discountState(cart, code);
      if (!(st.found && st.applicable)) { msg = 'That code isn’t valid for your bag.'; cls = 'is-error'; }
    }
    $all('[data-bind="promo-msg"]').forEach(function (el) { el.textContent = msg; el.classList.remove('is-ok', 'is-error'); if (cls) el.classList.add(cls); });
  }
  function applyDiscountAjax(code, trigger) {
    if (trigger) { trigger.disabled = true; trigger.setAttribute('aria-busy', 'true'); trigger.classList.add('is-loading'); }
    return fetch(CART_UPDATE, { method: 'POST', headers: JSONH, body: JSON.stringify({ discount: code == null ? '' : code }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { current = cart; render(cart, true); showPromo(cart, code); return cart; })
      .catch(function (e) { console.error('OCP discount:', e.message); })
      .finally(function () { if (trigger) { trigger.disabled = false; trigger.removeAttribute('aria-busy'); trigger.classList.remove('is-loading'); } });
  }
  // Remove ONE applied code (re-applies the others; '' clears the last). Automatic discounts can't be removed.
  function removeDiscount(code, trigger) {
    var remaining = ((current && current.discount_codes) || [])
      .filter(function (c) { return c.applicable && (c.code || '').toLowerCase() !== (code || '').toLowerCase(); })
      .map(function (c) { return c.code; }).join(',');
    if (trigger) trigger.disabled = true;
    return fetch(CART_UPDATE, { method: 'POST', headers: JSONH, body: JSON.stringify({ discount: remaining }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { current = cart; render(cart, true); showPromo(cart, null); })
      .catch(function (e) { console.error('OCP remove discount:', e.message); });
  }
  function discountChipHTML(title, amount, isCode) {
    return '<span class="cart-discount' + (isCode ? ' cart-discount--code' : ' cart-discount--auto') + '">'
      + '<svg class="cart-discount__ico" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 9h.01M15 15h.01M16 8l-8 8"/><path d="M21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.84z"/></svg>'
      + '<span class="cart-discount__label">' + esc(title) + '</span>'
      + (amount ? '<b class="cart-discount__amt">− ' + money(amount) + '</b>' : '')
      + (isCode ? '<button type="button" class="cart-discount__x" data-action="remove-discount" data-code="' + esc(title) + '" aria-label="Remove discount ' + esc(title) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' : '<span class="cart-discount__auto-tag">Automatic</span>')
      + '</span>';
  }
  // Render applied discounts (code + automatic) as chips, in every shell (cart page + popup).
  // Aggregates BOTH cart-level applications and line-level allocations (a % code is allocated per line),
  // grouped by title; `discount_application.type === 'discount_code'` ⇒ removable code, else automatic.
  function renderDiscounts(cart) {
    if (!cart) return;
    var agg = {}; // title(lower) -> { title, amount, isCode }
    function add(app, amount) {
      if (!app || !app.title) return;
      var k = app.title.toLowerCase();
      if (!agg[k]) agg[k] = { title: app.title, amount: 0, isCode: app.type === 'discount_code' };
      agg[k].amount += (amount || 0);
    }
    (cart.cart_level_discount_applications || []).forEach(function (a) { add(a, a.total_allocated_amount); });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) { add(al.discount_application, al.amount); });
    });
    // Safety net: any applied code with no surfaced allocation (e.g. free-shipping) still gets a chip.
    (cart.discount_codes || []).forEach(function (c) {
      if (c.applicable && !agg[(c.code || '').toLowerCase()]) agg[(c.code || '').toLowerCase()] = { title: c.code, amount: 0, isCode: true };
    });
    var html = Object.keys(agg).map(function (k) { return discountChipHTML(agg[k].title, agg[k].amount, agg[k].isCode); }).join('');
    $all('[data-bind="cart-discounts"]').forEach(function (el) { el.innerHTML = html; el.hidden = !html; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (!t) return;
    var action = t.getAttribute('data-action');

    if (action === 'add-to-cart') {
      var pc = t.closest('.pcard'); if (!pc) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var vid = t.getAttribute('data-variant-id') || pc.getAttribute('data-variant-id');
      var qEl = pc.querySelector('[data-bind-card="qty"]');
      addVariant(vid, qEl ? (parseInt(qEl.textContent, 10) || 1) : 1, t);
      return;
    }
    // Jeff 09/26: the collection/search card's "Purchase a Swatch" button. Always quantity 1 — the
    // card's qty stepper belongs to the yardage above it, not to the sample. data-variant-id is kept
    // current by ocp-app.js as the shopper changes colour.
    if (action === 'pcard-swatch-buy') {
      e.preventDefault(); e.stopImmediatePropagation();
      addVariant(t.getAttribute('data-variant-id'), 1, t);
      return;
    }
    if (action === 'pdp-add') {
      e.preventDefault(); e.stopImmediatePropagation();
      var pdp = t.closest('.pdp');
      var pvid = t.getAttribute('data-variant-id') || (pdp && pdp.getAttribute('data-variant-id'));
      var qInput = document.getElementById('pdp-qty');
      addVariant(pvid, qInput ? (parseInt(qInput.value, 10) || 1) : 1, t);
      return;
    }
    if (action === 'open-cart') {
      e.preventDefault(); e.stopImmediatePropagation();
      if (current) { render(current); openPopup(); } else { fetchCart().then(function (c) { render(c); openPopup(); }); }
      return;
    }
    if (action === 'cart-remove') {
      var rrow = t.closest('[data-key]'); if (!rrow) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var rkey = rrow.getAttribute('data-key');
      // Report before the line is gone — afterwards there is nothing left to describe.
      var rItem = current && current.items.filter(function (i) { return i.key === rkey; })[0];
      if (rItem) gaEvent('remove_from_cart', [rItem], rItem.final_line_price);
      clearTimeout(pendingTimers[rkey]); delete pendingQty[rkey]; // drop any pending step
      setBusy(rkey, true); changeLine(rkey, 0);
      return;
    }
    if (action === 'cart-inc' || action === 'cart-dec') {
      var row = t.closest('[data-key]'); if (!row) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (row.classList.contains('is-busy')) return; // a commit is mid-flight on this line
      var key = row.getAttribute('data-key');
      var item = current && current.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      bumpQty(item, action === 'cart-inc' ? 1 : -1); // debounced: commits the final qty + tier once
      return;
    }
    if (action === 'apply-promo') {
      // AJAX discount via /cart/update.js — applies + re-renders totals with no page reload.
      e.preventDefault(); e.stopImmediatePropagation();
      applyDiscountAjax(promoCodeIn(t), t.querySelector('.cart-sb__apply') || (t.tagName === 'BUTTON' ? t : null));
      return;
    }
    if (action === 'remove-discount') {
      e.preventDefault(); e.stopImmediatePropagation();
      removeDiscount(t.getAttribute('data-code'), t);
      return;
    }
    if (action === 'checkout') {
      // Cart PAGE uses a native <button type="submit" name="checkout"> form post — leave that alone.
      if ((t.getAttribute('type') || '').toLowerCase() === 'submit') return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!current || !current.item_count) return; // empty guard
      var shell = t.closest('.cart-popup, .cart-drawer, .cart-page, #cart-popup, #cart-drawer') || document;
      var code = promoCodeIn(shell);
      var checkoutUrl = R.checkout || '/checkout';
      // Apply a still-unapplied code first (carries to checkout via the cart), then go.
      if (code && !discountState(current, code).found) applyDiscountAjax(code).then(function () { window.location.href = checkoutUrl; });
      else window.location.href = checkoutUrl;
      return;
    }
    if (action === 'toggle-wish') {
      // let ocp-app.js handle the wishlist, then restore the Shopify cart render it may have wiped
      if (current) setTimeout(function () { render(current); }, 0);
    }
  }, true);

  function promoCodeIn(scope) {
    var input = scope && scope.querySelector && scope.querySelector('input[name="discount"], input[name="promo"], #cart-popup-promo, input[type="text"]');
    return input ? input.value.trim() : '';
  }

  // Enter inside the promo field applies via AJAX (and stops the cart form from posting/reloading).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('input[name="discount"], input[name="promo"]');
    if (!input) return;
    e.preventDefault(); e.stopImmediatePropagation();
    applyDiscountAjax(input.value.trim());
  }, true);
  // Belt-and-suspenders: a real <form> submit on the promo wrapper also applies via AJAX.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-action="apply-promo"]');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    applyDiscountAjax(promoCodeIn(form));
  }, true);

  window.addEventListener('scroll', syncStickyCheckout, { passive: true });
  window.addEventListener('resize', syncStickyCheckout);

  // Expose a minimal cart API for other OCP modules (e.g. the PDP "Purchase Swatch" button,
  // which adds a specific variant id that isn't the resolved add-to-bag variant).
  window.OCP_cartAdd = function (variantId, qty, trigger) { addVariant(variantId, qty, trigger); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fetchCart().then(render).catch(function () {}); });
  } else {
    fetchCart().then(render).catch(function () {});
  }
})();
